var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Field',{attrs:{"label":_vm.pLabel}},[_c('a',{attrs:{"href":'tel:' + _vm.pValue}},[_vm._v(_vm._s(_vm.pValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }